export interface ArtworkImage {
  image: string;
  width: number;
  height: number;
}

export const IMAGES: ArtworkImage[] = [
  { image: './assets/works/42.jpg', width: 604, height: 850 },
  { image: './assets/works/43.jpg', width: 850, height: 245 },
  { image: './assets/works/44.jpg', width: 850, height: 603 },
  { image: './assets/works/45.jpg', width: 549, height: 853 },
  { image: './assets/works/46.jpg', width: 850, height: 411 },
  { image: './assets/works/47.jpg', width: 850, height: 870 },
  { image: './assets/works/48.jpg', width: 850, height: 343 },
  { image: './assets/works/2.jpg', width: 2614, height: 2584 },
  { image: './assets/works/3.jpg', width: 2976, height: 3968 },
  { image: './assets/works/4.jpg', width: 3968, height: 2976 },
  { image: './assets/works/7.jpg', width: 2976, height: 3968 },
  { image: './assets/works/10.jpg', width: 3968, height: 2976 },
  { image: './assets/works/11.jpg', width: 3968, height: 2976 },
  { image: './assets/works/12.jpg', width: 3968, height: 2976 },
  { image: './assets/works/13.jpg', width: 3968, height: 2976 },
  { image: './assets/works/14.jpg', width: 3133, height: 2277 },
  { image: './assets/works/16.jpg', width: 3057, height: 1771 },
  { image: './assets/works/17.jpg', width: 1977, height: 3596 },
  { image: './assets/works/19.jpg', width: 3848, height: 1810 },
  { image: './assets/works/20.jpg', width: 2151, height: 2899 },
  { image: './assets/works/21.jpg', width: 928, height: 1146 },
  { image: './assets/works/22.jpg', width: 1920, height: 2560 },
  { image: './assets/works/23.jpg', width: 1600, height: 1548 },
  { image: './assets/works/24.jpg', width: 841, height: 1600 },
  { image: './assets/works/25.jpg', width: 1600, height: 1564 },
  { image: './assets/works/26.jpg', width: 1540, height: 1600 },
  { image: './assets/works/27.jpg', width: 1219, height: 1331 },
  { image: './assets/works/28.jpg', width: 1536, height: 1536 },
  { image: './assets/works/29.jpg', width: 1600, height: 1204 },
  { image: './assets/works/30.jpg', width: 1600, height: 1588 },
  { image: './assets/works/31.jpg', width: 1600, height: 1204 },
  { image: './assets/works/32.jpg', width: 1204, height: 1600 },
  { image: './assets/works/33.jpg', width: 1536, height: 1536 },
  { image: './assets/works/34.jpg', width: 431, height: 401 },
  { image: './assets/works/35.jpg', width: 1566, height: 1600 },
  { image: './assets/works/36.jpg', width: 1578, height: 1600 },
  { image: './assets/works/37.jpg', width: 1204, height: 1600 },
  { image: './assets/works/38.jpg', width: 900, height: 1600 },
  { image: './assets/works/39.jpg', width: 1496, height: 1489 },
  { image: './assets/works/40.jpg', width: 1204, height: 1600 },
  { image: './assets/works/41.jpg', width: 1600, height: 980 },
];

export function responsiveSourceSet(artwork: ArtworkImage): string {
  const filename = artwork.image.split('/').pop() ?? '';
  const sources: string[] = [];

  if (artwork.width > 800) {
    sources.push(`./assets/works/responsive/${filename.replace('.jpg', '-800.jpg')} 800w`);
  }
  if (artwork.width > 1600) {
    sources.push(`./assets/works/responsive/${filename.replace('.jpg', '-1600.jpg')} 1600w`);
  }
  sources.push(`${artwork.image} ${artwork.width}w`);

  return sources.join(', ');
}
